import { render, staticRenderFns } from "./BridgeSystemViewPage.vue?vue&type=template&id=2108ebbb&scoped=true&"
import script from "./BridgeSystemViewPage.vue?vue&type=script&lang=ts&"
export * from "./BridgeSystemViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./BridgeSystemViewPage.vue?vue&type=style&index=0&id=2108ebbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108ebbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VSelect,VSimpleTable,VTextField})
